<template>
  <div class="list-view-detail">
    <cell-logger-wrapper-auto-complete
      v-for="(cell, index) in cellList"
      :key="`search_auto_complete_cell_${index}`"
      :cell-info="cell"
      :index="index"
    >
      <template #clickable-cell>
        <component
          :is="thumbnailInfo.componentName"
          :cell-info="cell"
          :thumbnail-info="thumbnailInfo"
        />
      </template>
    </cell-logger-wrapper-auto-complete>
  </div>
</template>
<script>
import PortraitCell from '@/components/model/cell/PortraitCell'
import CellLoggerWrapperAutoComplete from '@/components/model/cellWrapper/CellLoggerWrapperAutoComplete'

export default {
  name: 'SearchAutoCompleteCellList',
  components: {
    PortraitCell,
    CellLoggerWrapperAutoComplete
  },
  props: {
    cellList: {
      type: Array
    },
    thumbnailInfo: {
      type: Object
    }
  }
}
</script>
